/**
 * Youtube Video Grid block: styles + YouTube poster fallback.
 */
import './style.scss';

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.youtube-video-grid__img[data-youtube-id]' )
		.forEach( ( img ) => {
			img.addEventListener(
				'error',
				() => {
					const id = img.getAttribute( 'data-youtube-id' );
					if ( ! id || img.dataset.posterFallback === '1' ) {
						return;
					}
					img.dataset.posterFallback = '1';
					img.src = `https://img.youtube.com/vi/${ id }/hqdefault.jpg`;
				},
				{ once: true }
			);
		} );
} );
